import { Observable, of } from 'rxjs'
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  RouterStateSnapshot,
} from '@angular/router'
import { Injectable } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { catchError, filter, map, switchMap, switchMapTo, take, tap } from 'rxjs/operators'
import * as fromRoot from '@tv3/store/state'
import {
  IsDataLoaded,
  loadRentalsPrimaryImages,
  selectIsPrimaryImagesLoaded,
  selectRentalsLoaded,
} from '@tokeet-frontend/tv3-platform'

@Injectable({ providedIn: 'root' })
export class RentalsPrimaryImageGuard implements CanActivate, CanActivateChild, CanLoad, IsDataLoaded {
  constructor(private store: Store<fromRoot.State>) {}

  public canActivate(): Observable<boolean> {
    return this.isDataLoaded().pipe(
      switchMapTo(of(true)),
      catchError(() => of(false))
    )
  }

  isDataLoaded(): Observable<boolean> {
    return this.store.pipe(
      select(selectRentalsLoaded),
      filter((loaded) => loaded),
      // load after rental loaded,
      switchMap(() => this.store.pipe(select(selectIsPrimaryImagesLoaded))),
      tap((isLoaded) => {
        if (!isLoaded) {
          this.store.dispatch(loadRentalsPrimaryImages({}))
        }
      }),
      map(() => true),
      take(1)
    )
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate()
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate()
  }
}
